import React from "react";
import {
  Create,
  FormDataConsumer,
  SelectInput,
  TextInput,
  BooleanInput,
  required,
  ReferenceInput,
  ImageInput,
  ImageField,
  TabbedForm,
  SimpleForm,
  FormTab,
  DateInput, NumberInput, AutocompleteInput,
  useNotify
} from "react-admin";
import { useStyles } from "../../../formStyles";
import { FormToolbar } from "../../../common/FormToolbar";
import moment from "moment";
import * as apiClient from "../../../common/apiClient";
import { toast } from "react-toastify";

const MotorClassDetails = (props) => {
  const classes = useStyles({});
  const notify = useNotify();
  let defaultValues = {
    isActive: true,
  };
  const handleSubmit = async (formdata) => {
    let user: any = localStorage.getItem("userId");
    if (user) {
      user = parseInt(user);
    }
    let m = moment();

    let data = { ...formdata };
    data.modifyBy = user;
    data.createdBy = user;
    data.modifyDate = m.toISOString();
    data.createdDate = m.toISOString();

    apiClient.addRecord(data, "motors").then(res => {
      notify("Motor is added succesffully");
      props.onClose();

    }).catch(err => {
      notify("unable to add Motor ", "warning");
      toast.error("Validation issue : " + err, {
        position: "bottom-center",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
      });
      console.log(err);
    });
  }

  return (
    <React.Fragment>
      <h5>Add Motor Details </h5>
      <SimpleForm variant="outlined" basePath="motors" toolbar={<FormToolbar {...props} showDelete={false} showCancel={true} onCancel={props.onClose} onSave={handleSubmit} />} redirect="list" onSubmit={handleSubmit} initialValues={defaultValues} >

      <TextInput source="make" label="Motor Make" fullWidth={true} validate={[required()]} formClassName={classes.one_three_input} />
          <TextInput source="model" label="Model" fullWidth={true} validate={[required()]} formClassName={classes.two_three_input} />
          <TextInput source="variant" label="Variant" fullWidth={true} validate={[required()]} formClassName={classes.last_three_input} />

          <TextInput source="fuel" label="Fuel" fullWidth={true} validate={[required()]} formClassName={classes.one_three_input} />
          <NumberInput label="CC/GVW" fullWidth={true} validate={[required()]} source="ccGvw" formClassName={classes.two_three_input} />
          <NumberInput label="Seating Capacity" fullWidth={true} validate={[required()]} source="seatingCapacity" formClassName={classes.last_three_input} />

          <TextInput source="rtoLoc" label="RTO Location" fullWidth={true} validate={[required()]} formClassName={classes.one_three_input} />
          <TextInput source="yearOfMfg" label="Year Of Manufacturing" fullWidth={true} validate={[required()]} formClassName={classes.two_three_input} />
          <NumberInput label="NCB Percentage" source="ncbPercentage" fullWidth={true} validate={[required()]}  formClassName={classes.last_three_input} />
          
          <TextInput source="regnNo" label="Registration Number" fullWidth={true} validate={[required()]} formClassName={classes.one_three_input} />
          <TextInput source="engineNo" label="Engine Number" fullWidth={true} validate={[required()]} formClassName={classes.two_three_input} />
          <TextInput source="chasisNo" label="Chasis Number" fullWidth={true} validate={[required()]} formClassName={classes.last_three_input} />

          <BooleanInput source="isActive" validate={[required()]} label="Active" initialValue={true} formClassName={classes.one_three_input} />

      </SimpleForm>

    </React.Fragment>
  );
};
export default MotorClassDetails;